import { DatePicker } from '@pankod/refine-antd';
import dayjs from 'dayjs';
import { forwardRef } from 'react';

interface SingleDatePickerProps {
  value: dayjs.Dayjs;
  onChange: (values: any, formatString: string) => void;
  format?: string;
  customDisabledDate?: (date: dayjs.Dayjs) => boolean;
}

export const SingleDatePicker = forwardRef<any, SingleDatePickerProps>((props, ref) => {
  const defaultDisabledDate = (date: dayjs.Dayjs) => date > dayjs();
  return (
    <DatePicker
      ref={ref}
      style={{ width: '100%' }}
      value={props.value}
      onChange={props.onChange}
      format={props.format || 'DD-MM-YYYY'}
      defaultValue={dayjs()}
      disabledDate={props.customDisabledDate || defaultDisabledDate}
    />
  );
});
